// import ClassicEditor from 'ckeditor/ckeditor';

CKEDITOR.editorConfig = function(config) {
  config.font_names = '標楷體/標楷體, Microsoft JhengHei, DFKai-SB, sans-serif;'+
  'Arial/Arial, Helvetica, sans-serif;' +
  'Comic Sans MS/Comic Sans MS, cursive;' +
  'Courier New/Courier New, Courier, monospace;' +
  'Georgia/Georgia, serif;' +
  'Lucida Sans Unicode/Lucida Sans Unicode, Lucida Grande, sans-serif;' +
  'Tahoma/Tahoma, Geneva, sans-serif;' +
  'Times New Roman/Times New Roman, Times, serif;' +
  'Trebuchet MS/Trebuchet MS, Helvetica, sans-serif;' +
  'Verdana/Verdana, Geneva, sans-serif;' ;
};
// ClassicEditor.create( document.querySelector( '#editor' ), {
//   extraAllowedContent: 'a[*]{*}(*)',
//   removeDialogTabs: 'link:advanced'
// } );

CKEDITOR.config.autoLink = true;
// CKEDITOR.config.extraPlugins = 'autolink';

// // // 自動連結偵測設定
// CKEDITOR.config.autolink_defaultProtocol = 'http://';
// CKEDITOR.config.autolinkedUrlSchemes = ['http', 'https', 'ftp'];

// CKEDITOR.config.autolink_regex_default = '\\b((?:[A-Za-z]+:)?//)?((?:[0-9]{1,3}\\.){3}[0-9]{1,3}|(?:www\\.|[A-Za-z0-9]+[A-Za-z0-9-]*\\.[A-Za-z]{2,}))(:[0-9]+)?(/[^\\s]*)?\\b';
